import PureFlow from '../../pages/pure-flow/PureFlow'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.PURE_FLOW, component: PureFlow },
])
